import { Link } from "react-router-dom";
import { movies, tvShows } from "@/mocks/media";
import MovieCard from "@/components/base/MovieCard";
import SectionHeading from "@/components/base/SectionHeading";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntry from "./components/CategoryEntry";
import HotList from "./components/HotList";
import IntroSection from "./components/IntroSection";

export default function Home() {
  const allMedia = [...movies, ...tvShows];

  const featured = allMedia.filter((item) => item.featured && item.backdrop);
  const latest = [...allMedia].sort((a, b) => b.year - a.year).slice(0, 12);
  const hot = [...allMedia].sort((a, b) => b.views - a.views).slice(0, 8);

  return (
    <div className="w-full">
      <HeroCarousel items={featured} />

      <CategoryEntry />

      <section className="w-full px-4 md:px-8 pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-8">
          <div>
            <SectionHeading
              title="最新上线"
              subtitle="最近更新的电影与电视剧精选"
              icon="ri-time-line"
              action={
                <Link
                  to="/category/movie"
                  className="hidden sm:inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  查看全部
                  <i className="ri-arrow-right-line"></i>
                </Link>
              }
            />
            <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4" data-product-shop>
              {latest.map((item) => (
                <MovieCard key={item.id} item={item} />
              ))}
            </div>
          </div>

          <aside>
            <SectionHeading title="热门推荐" subtitle="按浏览热度排名" icon="ri-fire-line" />
            <HotList items={hot} />
          </aside>
        </div>
      </section>

      <IntroSection />
    </div>
  );
}